const pieChart = {
  series: [0, 0, 0],
  chartOptions: {
    labels: ["Approved", "Rejected", "Incomplete"],
    colors: ["#5cb85c", "#dc3545", "#f1b44c"],
    noData: {
      text: "No Reviewed Applications",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: "#8c98a5",
        fontSize: "14px",
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "14px",
      offsetX: 0,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  },
};

export { pieChart };
